import { OrganizationRedirect } from "@components/organizationView/OrganizationRedirect";
import { Route } from "react-router-dom";

const REDIRECT_MAP: Record<string, string> = {
    "/clients": "/",
    // "/team": "/team",
    // "/organization-billing": "/organization-billing",
    // "/organization-settings": "/organization-settings",
};

export function useRenderOrganizationRedirectRoutes() {
    return Object.entries(REDIRECT_MAP).map(([path, redirectPath]) => (
        <Route
            key={path}
            path={path}
            element={<OrganizationRedirect path={redirectPath} />}
        />
    ));
}
